module.exports = __webpack_public_path__ + "static/media/mycollection-bg.d30fa4a8.png";